/**
 * Created by Daniela on 27/01/2017.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import {TanqueNavigationService} from "../shared/tanque-navigation.service";
import {tanquesEstoqueModuleName, TiposMovimentacoesTanques, tanquesModuleName} from "../shared/data.service";
import {TanqueApiService} from "../shared/tanque-api.service";
import {UtilService} from "../../../shared/services/util.service";
import {TanqueService} from "../shared/tanque.service";
import {MovimentacaoTanque} from "../shared/tanque.model";
import {Area} from "../../../estruturas/areas/shared/area.model";
import {Bomba} from "../../bombas/shared/bomba.model";
import {AreaApiService} from "../../../estruturas/areas/shared/area-api.service";
import {BombaApiService} from "../../bombas/shared/bomba-api.service";
import {FilterService} from "../../../shared/services/filter.service";
import {abastecimentosModuleName} from "../../shared/data.service";

@Component({
    template: require('./tanque-movimentacao-detail.component.html'),
    styles: [require('./tanque-movimentacao-detail.component.css')]
})
export class TanqueMovimentacaoDetailComponent implements OnInit {
    detail: any = {};
    list: any[] = [];
    loading: boolean = true;
    tanquesEstoqueModuleName: any = tanquesEstoqueModuleName;
    tanquesModuleName: any = tanquesModuleName;
    tipoEntrada: number;
    tipoSaida: number;
    tipoEstorno: number;
    tipoAjuste: number;
    tipoTransferencia: number;
    showDisabled: boolean = false;
    areasList: Area[] = [];
    bombasList: Bomba[] = [];
    tipoLancamentosList: any[] = [];
    periodosList: any[] = [];
    periodoSearch: any = {};
    bombaSearch: any = {};
    areaSearch: any = {};
    lancamentoSearch: any = {};
    loadingBombas: boolean = true;
    loadingAreas: boolean = true;
    tanqueId: number;
    module: any = abastecimentosModuleName;

    private movimentacoesAreasList: any[] = [];
    private cloneList: any[] = [];

    constructor(
        private _tanqueNavigationService: TanqueNavigationService,
        private _tanqueApiService: TanqueApiService,
        private _utilService: UtilService,
        private _tanqueService: TanqueService,
        private _areaApiService: AreaApiService,
        private _bombaApiService: BombaApiService,
        private _filterService: FilterService,
        private _route: ActivatedRoute
    ) { }

    ngOnInit() {
        let tipo: any = this._tanqueService.getTipoMovimentacaoEntrada();
        this.tipoEntrada = tipo.Key;
        tipo = this._tanqueService.getTipoMovimentacaoSaida();
        this.tipoSaida = tipo.Key;
        tipo = this._tanqueService.getTipoMovimentacaoEstorno();
        this.tipoEstorno = tipo.Key;
        tipo = this._tanqueService.getTipoMovimentacaoAjuste();
        this.tipoAjuste = tipo.Key;
        tipo = this._tanqueService.getTipoMovimentacaoTransferencia();
        this.tipoTransferencia = tipo.Key;

        this.tanqueId = +this._route.snapshot.params['id'];

        this.getTanque();
        this.getPeriodos();
        this.getTiposLancamentos();
        this.getAreas();
        this.getBombas();
    }

    clickGoToEstoque() {
        this._tanqueNavigationService.goToEstoque();
    }

    clickEdit(item: MovimentacaoTanque) {
        this._tanqueService.clearSessionStorage();
        this._tanqueNavigationService.goToMovimentacaoEdit(item.id);
    }

    clickDelete(item: MovimentacaoTanque) {
        let onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    changePeriodo() {
        this.queryMovimentacoes();
    }

    changeLancamento() {
        this.queryMovimentacoes();
    }

    changeArea() {
        this.queryMovimentacoes();
    }

    changeBomba() {
        this.queryMovimentacoes();
    }

    private getTiposLancamentos() {
        let list: any[] = this._utilService.cloneObject(TiposMovimentacoesTanques);
        list.unshift({Key: null, Value: '— Tipo de lançamento —'});
        this.tipoLancamentosList = list;
        this.lancamentoSearch = this.tipoLancamentosList[0];
    }

    private getAreas() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                let x: number, lenX: number, list: any[] = [];
                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    if (Response[x].ativo) {
                        list.push(Response[x]);
                    }
                }

                list.unshift({id: null, nome: '— Área —'});
                this.areasList = list;
                this.areaSearch = this.areasList[0];
            }

            this.loadingAreas = false;
        }.bind(this));

        this._areaApiService.onGetAll(onDone);
    }

    private getBombas() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                let x: number, lenX: number, list: any[] = [];
                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    if (Response[x].ativo) {
                        list.push(Response[x]);
                    }
                }

                list.unshift({id: null, nome: '— Bomba —'});
                this.bombasList = list;
                this.bombaSearch = this.bombasList[0];
            }

            this.loadingBombas = false;
        }.bind(this));

        this._bombaApiService.onGetByTanque(this.tanqueId, onDone);
    }

    private getMovimentacoes(query: any) {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                this.cloneList = this.formatMovimentacao(Response);
                this.checkMovimentacoesAreas();
            } else {
                this.loading = false;
            }
        }.bind(this));

        this.list = [];
        this.cloneList = [];
        this.loading = true;
        this._tanqueApiService.onGetByMovimentacaoFilter(query, onDone);
    }

    private getMovimentacoesAreas(query: any) {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                this.movimentacoesAreasList = Response;
                this.putAreasInMovimentacao();
            }

            this.loading = false;
        }.bind(this));

        this._tanqueApiService.onGetByMovimentacaoAreaFilter(query, onDone);
    }

    private getTanque() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                this.detail = Response;
            }
        }.bind(this));

        this._tanqueApiService.onGetById(this.tanqueId, onDone);
    }

    private formatMovimentacao(list: any[]) {
        let x: number, lenX: number, y: number, lenY: number,
            tiposMovimentacao: any[] = this._utilService.cloneObject(TiposMovimentacoesTanques);

        for (x = 0, lenX = list.length; x < lenX; x++) {
            for (y = 0, lenY = tiposMovimentacao.length; y < lenY; y++) {
                if (list[x].tipoLancamento === tiposMovimentacao[y].Key) {
                    list[x].tipoMovimentacao = tiposMovimentacao[y];
                    break;
                }
            }
        }

        return list;
    }

    private onDelete(item: any) {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                let x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._tanqueApiService.onDeleteMovimentacao(item.id, onDone);
    }

    private getPeriodos() {
        let list: any[] = [
            {Key: 1, Value: 'Últimos 7 dias', days: 7},
            {Key: 2, Value: 'Últimos 30 dias', days: 30},
            {Key: 3, Value: 'Últimos 3 meses', days: 90},
        ];

        this.periodosList = list;
        this.periodoSearch = this.periodosList[0];
        this.changePeriodo();
    }

    private queryMovimentacoes() {
        let query: any = {"order":"data DESC","where":{}};
        query.where = this.calcPeriodo(this.periodoSearch.days);
        query.where.or = [{tanqueId: this.tanqueId}, {tanqueDestinoId: this.tanqueId}];

        if (this.bombaSearch.id) {
            query.where.bombaId = this.bombaSearch.id;
        }

        if (this.lancamentoSearch.Key) {
            query.where.tipoLancamento = this.lancamentoSearch.Key;
        }

        this.getMovimentacoes(query);
    }

    private calcPeriodo(periodo: number) {
        let currDate = new Date();
        let currDay  = currDate.getDate(),
            currMonth = currDate.getMonth(),
            currYear = currDate.getFullYear();
        let currDate2 = new Date(currYear, currMonth, currDay);

        let today = currDate.getDate();

        let lastDate: any = new Date(currDate.getTime());
        lastDate.setDate(today - periodo);
        let lastDay = lastDate.getDate(),
            lastMonth = lastDate.getMonth(),
            lastYear = lastDate.getFullYear();
        let lastDate2 = new Date(lastYear, lastMonth, lastDay);

        //{"where":{"and":[{"data":{"gte":"2017-01-28T02:00:00.000Z"}},{"data":{"lte":"2017-01-30T02:00:00.000Z"}}]}}
        return {"and":[{"data":{"gte":lastDate2}},{"data":{"lte":currDate2}}]};
    }

    private checkMovimentacoesAreas() {
        let x: number, lenX: number, list: any[] = [];
        for (x = 0, lenX = this.cloneList.length; x < lenX; x++) {
            list.push({movimentacaoId: this.cloneList[x].id});
        }

        if (list.length) {
            let query: any = {"where": {"or": list}};
            this.getMovimentacoesAreas(query);
        } else {
            this.movimentacoesAreasList = [];
            this.putAreasInMovimentacao();
        }
    }

    private putAreasInMovimentacao() {
        let areasMovimentacoes = this.movimentacoesAreasList;
        if (this.areaSearch.id) {
            //pega todas as areasmovimentacoes que sejam iguais a area q esta sendo filtrada
            areasMovimentacoes = this._filterService.filterArray(this.movimentacoesAreasList, this.areaSearch.id, ["areaId"]);
        }

        ///coloca as areas nas movimentacoes
        this.cloneList.forEach(function(item: any) {
            item.areas = this._filterService.filterArray(areasMovimentacoes, item.id, ["movimentacaoId"]);
        }.bind(this));

        if (this.areaSearch.id) {
            //remove todas as movimentacoes que nao tenham area
            let x: number, lenX: number,
                list: any[] = this._utilService.cloneObject(this.cloneList),
                list2: any[] = [];

            for (x = 0, lenX = list.length; x < lenX; x++) {
                if (list[x].areas.length || (list[x].areaId === this.areaSearch.id)) {
                    list2.push(list[x]);
                }
            }

            this.list = list2;
        } else {
            this.list = this._utilService.cloneObject(this.cloneList);
        }

        this.loading = false;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tanques/tanque-movimentacao-detail/tanque-movimentacao-detail.component.ts
 **/